module.exports = __webpack_public_path__ + "img/image.a2839db9.svg";